/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGlobalSettings } from "../types/settings";
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";

const routePrefix = "datalake/settings";

export default {
  async getSettings(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}`);
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load the settings."
        );
        throw error;
      }
    }
  },
  async setSettings(update: Partial<IGlobalSettings>): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}`, { update });
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save settings."
        );
        throw error;
      }
    }
  },
};
